module.exports = __webpack_public_path__ + "img/turbo-vpn.67b5fba.png";